import { Inject, Injectable } from '@angular/core';
import { GtagConfig, GtagEvent, GtagPageview } from './interfaces';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
declare var gtag: any;

@Injectable()
export class Gtag {

  constructor(@Inject('config') gaConfig: GtagConfig, private router: Router) {

/*
    router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(event => {
          this.pageview();
        })
      )
      .subscribe();
*/

  }

  event(action: string, params: GtagEvent = {}) {
    // try/catch to avoid cross-platform issues
    try {
      gtag('event', action, params);
    } catch (err) {
      console.error('Google Analytics event error', err);
    }
  }

  pageview(params?: GtagPageview) {
    try {
/*
      const defaults = {
        page_path: this.router.url,
        page_title: 'dewabit',
        page_location: window.location.href
      };

      params = { ...defaults, ...params };
      gtag('config', this.mergedConfig.trackingId, params);
*/
    } catch (err) {
      console.error('Google Analytics pageview error', err);
    }
  }

}
